import { Component, type ErrorInfo, type ReactNode } from 'react'

interface Props {
  children: ReactNode
  fallback?: (error: Error, reset: () => void) => ReactNode
}
interface State {
  error: Error | null
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[EventPro] Render error:', error, info)
    // TODO: enviar pro Sentry
  }

  reset = () => {
    this.setState({ error: null })
  }

  render() {
    const { error } = this.state
    if (!error) return this.props.children
    if (this.props.fallback) return this.props.fallback(error, this.reset)
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="max-w-xl bg-card border border-danger rounded-2xl p-7">
          <div className="text-3xl mb-2">⚠️</div>
          <h2 className="font-bold text-xl mb-2">Ops, algo travou no sistema</h2>
          <p className="text-text-secondary text-sm mb-4">
            Os dados estão salvos. Recarregue a página para continuar.
          </p>
          <pre className="bg-bg border border-border rounded p-3 text-xs text-warning overflow-auto max-h-48 whitespace-pre-wrap">
            {error.message}
          </pre>
          <div className="flex gap-3 mt-4">
            <button onClick={() => location.reload()} className="bg-accent text-white rounded-lg px-4 py-2 font-bold">
              Recarregar
            </button>
            <button onClick={this.reset} className="text-text-secondary border border-border rounded-lg px-4 py-2 font-bold">
              Tentar novamente
            </button>
          </div>
        </div>
      </div>
    )
  }
}
